// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"437":"8b5b7920","453":"4d026563","473":"34a6e9c8","493":"64b82da9","549":"3ee6c221","640":"1f8fdaf5","823":"7b9cc445","846":"9c8c2e0b"}[chunkId] + ".chunk.js";
};